<template>
  <div class='EnbWa'>
    <div class="card-wa">
      <div class="top-check">
        <input :disabled="Empresa.wa" @change="toggle" :checked="Empresa.wa" type="checkbox"/>
        <label>Envia pedido no Whatsapp</label>
      </div>
      <div class="cont-input">
        <input-reg
        text="Número"
        :value="Empresa.whatsapp"
        @update:modelValue="newValue => numero = newValue"
        :cont="{ textAlign: 'left' }"
        :label="{ marginLeft: '3px' }"
        :input="{ fontSize: '16px', padding: '2%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        :Mask="['(##) #####-####']"
        />
      </div>
      <div class="cont-button">
        <button @click="push">Salvar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
export default {
  name: 'EnbWa',
  components: { InputReg },
  data () {
    return {
      numero: ''
    }
  },
  computed: {
    ...mapGetters(['Empresa']),
    whats () {
      return this.numero.replace('(', '').replace(')', '').replace(' ', '').replace('-', '')
    }
  },
  methods: {
    ...mapActions(['_UpdateParamWa', '_UpdatePayMode']),
    push () {
      this._UpdateParamWa(this.whats)
    },
    toggle () {
      if(this.Empresa.wa) {
        return
      }
      this._UpdatePayMode({ mp: false, wa: true })
    }
  }
}
</script>

<style scoped>
.EnbWa {
  display: flex;
  margin-top: 2%;
}

.card-wa {
  width: 45%;
  border: thin solid #CCCCCC;
  border-radius: 10px;
}

.top-check {
  height: 35px;
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  background-color: #EEEEEE;
  color: #648EEA;
}

input {
  margin-left: 2%;
}

.cont-input {
  padding: 2%;
}

.cont-button {
  display: flex;
  padding-left: 2%;
  padding-bottom: 2%;
}

button {
  border: 0;
  background-color: #000000;
  color: #FFFFFF;
  padding: 1.5%;
  border-radius: 5px;
  cursor: pointer;
}

@media (max-width: 500px) {
  .card-wa {
    width: 100%;
    margin: auto;
  }
}
</style>
